// extracted by mini-css-extract-plugin
export default {"select":"CustomFormSelect_select__Ka+uG"};